<div class="card mt-2">
    <div class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom-0 full">
        <div class="column full" style="width: 100%;">
            <h6 class="mt-3">Tabla {{selectedToggle == "COMPRA" ? "proveedores":"clientes"}}</h6>
            <div class="table-responsive table-entidad mt-3">

                <div *ngIf="isLoadingTable" class="mt-5" style="height: 600px;">
                    <app-loader-w-message loadingMessage=""></app-loader-w-message>
                </div>

                <div *ngIf="!isLoadingTable">
                    <select class="form-control no-print pagination-custom" #periodosSelect (change)="cambioPaginacion(periodosSelect.value)">
                        <option *ngFor="let element of paginationOptions" [value]="element">
                            {{ element }}
                        </option>
                    </select>
                    
                    <table id="example-datatable" class="table table-vcenter table-condensed table-bordered">
                        <thead>
                            <tr>
                                <th class="text-center bg-primary" style="color:#fff; font-size: 13px;">{{selectedToggle == "COMPRA"? "Tipo de Compra" : "Tipo de Venta"}}</th>
                                <th class="bg-primary" style="color:#fff; font-size: 13px;">RUT {{selectedToggle == "COMPRA"? "Proveedor" : "Cliente"}}</th>
                                <th class="bg-primary" style="color:#fff; font-size: 13px;">Razón Social</th>
                                <th class="bg-primary" style="color:#fff; font-size: 13px;">Folio</th>
                                <th class="bg-primary" style="color:#fff; font-size: 13px;">Fecha Documento</th>
                                <th class="bg-primary" style="color:#fff; font-size: 13px;">Fecha Recepción</th>
                                <th class="bg-primary" style="color:#fff; font-size: 13px;">Fecha Acuse</th>
                                <th class="bg-primary" style="color:#fff; font-size: 13px;">Monto Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="paginaActual.length > 0; else noPage">
                                <!-- REVISAR WEB CLIENTES PARA APLICAR PIPES (paginacion, rut etc) -->
                                <tr *ngFor="let report of paginaActual">
                                    <td *ngIf="selectedToggle == 'COMPRA'" class="text-center">{{report?.TipoCompra}}</td>
                                    <td *ngIf="selectedToggle == 'COMPRA'">{{report?.RUTProveedor ? (report?.RUTProveedor) : ''}}</td>
                                    
                                    <td *ngIf="selectedToggle == 'VENTA'" class="text-center">{{report?.TipoVenta}}</td>
                                    <td *ngIf="selectedToggle == 'VENTA'">{{report?.Rutcliente ? (report?.Rutcliente) : ''}}</td>
                                    
                                    <td>{{report?.RazonSocial}}</td>
                                    <td>{{report?.Folio}}</td>
                                    <td>{{(report?.FechaDocto) ? (esFormatoFecha(report?.FechaDocto) ? (cambiarFormatoFecha(report?.FechaDocto)) : (report?.FechaDocto | date: 'dd-MM-yyyy')) : '' }}</td>
                                    <td>{{(report?.FechaRecepcion) ? (esFormatoFechaHora(report?.FechaRecepcion) ? (cambiarFormatoFechaHora(report?.FechaRecepcion)) : (report?.FechaRecepcion | date: 'dd-MM-yyyy H:mm:ss')) : '' }}</td>
                                    
                                    <td *ngIf="selectedToggle == 'COMPRA'">{{(report?.FechaAcuse) ? (esFormatoFechaHora(report?.FechaAcuse) ? (cambiarFormatoFechaHora(report?.FechaAcuse)) : (report?.FechaAcuse | date: 'dd-MM-yyyy H:mm:ss')) : '' }}</td>
                                    <td *ngIf="selectedToggle == 'VENTA'">{{(report?.FechaAcuseRecibo) ? (esFormatoFechaHora(report?.FechaAcuseRecibo) ? (cambiarFormatoFechaHora(report?.FechaAcuseRecibo)) : (report?.FechaAcuseRecibo | date: 'dd-MM-yyyy H:mm:ss')) : '' }}</td>

                                    <td *ngIf="selectedToggle == 'COMPRA'">${{(report?.MontoTotal) ? (report?.MontoTotal | currency:'CLP':'':'1.0-0') : '' }}</td>
                                    <td *ngIf="selectedToggle == 'VENTA'">${{(report?.Montototal) ? (report?.Montototal | currency:'CLP':'':'1.0-0') : '' }}</td>
                                </tr>
                            </ng-container>
                            <ng-template #noPage>
                                <tr>
                                    <td colspan="100%">
                                        Sin información
                                    </td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
                <!-- PAGINACION -->
            </div>
            <mat-paginator #paginator
              [length]="cantidadRegistros"
              [pageSize]="currentItem"
              (page)="onPageChange($event)"
              hidePageSize="true"
              [disabled]="isLoadingTable"
              aria-label="Select page">
            </mat-paginator>
        </div>
    </div>
</div>